import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';

export default function AboutPage() {
  useEffect(() => {
    document.title = '关于我们 - 亚洲五码对照指南';
  }, []);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于我们 - 亚洲五码对照指南',
    description: '亚洲五码对照指南致力于为消费者提供最精准的亚洲五码与欧码、美码、英码换算对照服务。',
    mainEntity: {
      '@type': 'Organization',
      name: '亚洲五码对照指南',
      description: '专业尺码对照平台',
      url: 'https://docbihd.cn',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        email: 'contact@docbihd.cn',
      },
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <ScrollToTop />
      <Navbar />
      <main className="pt-16">
        <Breadcrumb items={[{ name: '首页', path: '/' }, { name: '关于我们' }]} />

        <section className="w-full px-4 md:px-6 py-12">
          <div className="max-w-3xl mx-auto">
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-8 text-center">关于我们</h1>

            <div className="mb-14">
              <h2 className="text-xl font-semibold text-foreground-950 mb-4">品牌介绍</h2>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                亚洲五码对照指南诞生于一个朴素的愿望——让每一个消费者都能轻松选对尺码。
              </p>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                随着跨境电商和线上购物的蓬勃发展，越来越多消费者面临尺码换算的困扰。亚洲五码与欧码、美码、英码之间的差异，常常导致买错尺码、反复退换货的烦恼。我们深知这种体验有多么令人沮丧。
              </p>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                为此，我们汇聚了资深鞋服行业专家和数据分析师，历时数月整理了涵盖鞋子、服装、童装等全品类的亚洲五码对照表。从男女鞋码到上衣裤装，从新生儿到青少年童装，我们力求提供最全面、最准确的尺码换算参考。
              </p>
              <p className="text-sm text-foreground-700 leading-relaxed">
                我们的对照数据参考了数十个主流品牌官方尺码表、国际尺码标准组织发布的数据，以及数万条真实消费者的反馈，确保每一条对照信息都经得起实践的检验。
              </p>
            </div>

            <div className="mb-14">
              <h2 className="text-xl font-semibold text-foreground-950 mb-4">品牌信誉</h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
                <div className="bg-background-100/70 rounded-lg p-6 text-center">
                  <div className="text-3xl font-bold text-primary-600 mb-2">10万+</div>
                  <p className="text-sm text-foreground-600">月均访问用户</p>
                </div>
                <div className="bg-background-100/70 rounded-lg p-6 text-center">
                  <div className="text-3xl font-bold text-primary-600 mb-2">50+</div>
                  <p className="text-sm text-foreground-600">覆盖品牌尺码数据</p>
                </div>
                <div className="bg-background-100/70 rounded-lg p-6 text-center">
                  <div className="text-3xl font-bold text-primary-600 mb-2">99%</div>
                  <p className="text-sm text-foreground-600">用户满意度</p>
                </div>
              </div>
            </div>

            <div className="mb-14">
              <h2 className="text-xl font-semibold text-foreground-950 mb-4">核心价值</h2>
              <div className="space-y-4">
                <div className="flex gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0">
                    <i className="ri-check-double-line text-lg"></i>
                  </div>
                  <div>
                    <h3 className="text-base font-medium text-foreground-900 mb-1">精准可靠</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">每一条对照数据都经过多渠道交叉验证，确保换算准确无误。</p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0">
                    <i className="ri-global-line text-lg"></i>
                  </div>
                  <div>
                    <h3 className="text-base font-medium text-foreground-900 mb-1">全面覆盖</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">涵盖鞋子、服装、童装全品类，男女老少一站式对照查询。</p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0">
                    <i className="ri-user-heart-line text-lg"></i>
                  </div>
                  <div>
                    <h3 className="text-base font-medium text-foreground-900 mb-1">用户至上</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">持续收集用户反馈，不断优化对照数据和用户体验。</p>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h2 className="text-xl font-semibold text-foreground-950 mb-6">联系我们</h2>
              <div className="bg-background-100/70 rounded-lg p-6 md:p-8">
                <p className="text-sm text-foreground-700 leading-relaxed mb-6">
                  如果您在使用过程中发现任何尺码对照不准确的地方，或有任何建议和反馈，欢迎通过以下表单与我们联系。我们会在48小时内回复。
                </p>

                <form
                  data-readdy-form
                  action="https://readdy.ai/api/form/d9tvl1n8l97n3eas3egg"
                  method="POST"
                  className="flex flex-col gap-4"
                >
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div className="flex flex-col gap-1.5">
                      <label htmlFor="name" className="text-sm font-medium text-foreground-800">姓名</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        required
                        className="px-4 py-2.5 border border-background-300/60 rounded-md text-sm text-foreground-900 bg-background-50 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                        placeholder="请输入您的姓名"
                      />
                    </div>
                    <div className="flex flex-col gap-1.5">
                      <label htmlFor="email" className="text-sm font-medium text-foreground-800">邮箱</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        required
                        className="px-4 py-2.5 border border-background-300/60 rounded-md text-sm text-foreground-900 bg-background-50 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                        placeholder="请输入您的邮箱"
                      />
                    </div>
                  </div>

                  <div className="flex flex-col gap-1.5">
                    <label htmlFor="subject" className="text-sm font-medium text-foreground-800">主题</label>
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      required
                      className="px-4 py-2.5 border border-background-300/60 rounded-md text-sm text-foreground-900 bg-background-50 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                      placeholder="请输入主题"
                    />
                  </div>

                  <div className="flex flex-col gap-1.5">
                    <label htmlFor="message" className="text-sm font-medium text-foreground-800">留言内容</label>
                    <textarea
                      id="message"
                      name="message"
                      required
                      rows={5}
                      maxLength={500}
                      className="px-4 py-2.5 border border-background-300/60 rounded-md text-sm text-foreground-900 bg-background-50 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors resize-none"
                      placeholder="请描述您的问题或建议（500字以内）"
                    ></textarea>
                    <span className="text-xs text-foreground-400">最多500字</span>
                  </div>

                  <input
                    type="text"
                    name="phone_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="form-field-offscreen"
                  />

                  <button
                    type="submit"
                    className="px-6 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors self-start"
                  >
                    提交留言
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}